import Model from "./base/model";

class State extends Model {
  resourceName() {
    return "states";
  }

  fields() {
    return {
      uf: "",
      name: "",
      country_id: "",
    };
  }
}
export default new State();
